export default "__VITE_ASSET__tj2qeeQL__"